// import data from '@/mock/data';
import { SHOPPINGCART, ADDRESS, USER, ORDER, PREORDER, USERS, TOKEN } from '@/const/localStorage';
import { NOTLOGIN } from '@/const/error';
import { computer, daily, office, electrical, seckill, carousel, deadline, recommend } from './mock';
// import shops from '@/mock/shop'
import { register } from '@/api/login';
import { getCata, getShop, getData } from '@/api/mall';
// import { add } from 'lodash';

// 获取秒杀数据
export const loadSeckillsInfo = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_SECKILLS_INFO', [seckill, deadline]);
  });
};

// 获取轮播(营销)图片
export const loadCarouselItems = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_CAROUSELITEMS_INFO', carousel);
  });
};

// 加载电脑专栏数据
export const loadComputer = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_COMPUTER_INFO', computer);
  });
};

// 加载日用百货专栏数据
export const loadEat = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_EAT_INFO', daily);
  });
};

// 加载办公用品
export const loadOffice = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_OFFICE_INFO', office);
  });
};

// 加载电器
export const loadElectrical = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_ELECTRICAL_INFO', electrical);
  });
};

// 请求获得商品详细信息
export const loadGoodsInfo = ({ state, commit }, payload) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const { id, cata } = payload;
      const goods = state.goods;
      const _data = goods[cata].filter(item => String(item.id) === String(id))[0];
      commit('SET_GOODS_INFO', _data || {});
      commit('SET_LOAD_STATUS', false);
    }, 300);
  });
};

// 获取商品列表
export const loadGoodsList = ({ state, commit }, payload) => {
  commit('SET_LOAD_STATUS', true);
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      const _data = {
        asItems: [
          {
            id: 8,
            cata: 'daily',
            secCata: 'daily-clean',
            img: 'static/img/index/eat/item-eat-1-6.jpg',
            price: 23,
            intro: '吸水毛巾家务清洁擦布',
            num: 110,
            sale: 610
          },
          {
            id: 40,
            cata: 'comp',
            secCata: 'comp-digital',
            img: 'static/img/index/computer/item-computer-4.jpeg',
            price: 42,
            intro: '夏科正品高速u盘32g',
            num: 160,
            sale: 8900
          },
          {
            id: 41,
            cata: 'comp',
            secCata: 'comp-audio',
            img: 'static/img/index/computer/item-computer-5.jpeg',
            price: 98,
            intro: '电脑音响台式家用多媒体低音炮',
            num: 135,
            sale: 8800
          },
          {
            id: 28,
            cata: 'office',
            secCata: 'office-pen',
            img: 'static/img/index/office/office-11.jpg',
            price: 23,
            intro: '晨光正品可擦彩色中性笔芯',
            num: 128,
            sale: 7990
          }
          // {
          //   id: 38,
          //   cata: 'electrical',
          //   secCata: 'electrical-protective',
          //   img: 'static/img/index/electrical/electrical-6.jpg',
          //   price: 68,
          //   intro: 'Lenovo/联想电子秤精准体重秤',
          //   num: 92,
          //   sale: 7600
          // }
        ],
        goodsList: []
      };

      let data = state.goods;

      if (data) {
        if ('type' in payload) {
          // 店铺
          let res = [];
          if (payload.type === 'merchant') {
            const { shopid } = payload;
            for (let key in data) {
              const currentShopItem = data[key].filter(item => String(item.shopid) === String(shopid)).map(item => ({...item, firCata: key}));
              res = res.concat(currentShopItem);
            };
            _data.goodsList = res;
          } else if (payload.type === 'search') { // 关键字搜索
            const { keyword } = payload;
            for (let key in data) {
              res = res.concat(data[key].filter(item => item.intro.indexOf(keyword) > -1).map(item => ({ ...item, cata: key })));
            };
          };

          _data.goodsList = res;
        } else if ('cata' in payload) {
          let _cata = data[payload.cata];
          _data.goodsList = _cata;

          if ('secCata' in payload) {
            if (payload.secCata !== 'all') _data.goodsList = _cata.filter(item => +item.cataid === +payload.secCata);
          }
        } else {
          _data.goodsList = [];
        }
      }

      commit('SET_GOODS_LIST', _data);
      commit('SET_LOAD_STATUS', false);
    });
  });
};

// 添加购物车
export const addShoppingCart = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    const shoppingCart = JSON.parse(localStorage.getItem(SHOPPINGCART)) || [];
    let currentUser = localStorage.getItem(USER);
    if (currentUser) {
      currentUser = JSON.parse(currentUser);
      shoppingCart.push({
        goodsId: data.goodsId,
        count: data.count,
        img: data.package.img,
        package: data.package.intro,
        price: data.package.price,
        title: data.title
      });
      localStorage.setItem(SHOPPINGCART, JSON.stringify(shoppingCart));
      commit('ADD_SHOPPING_CART', data);
      resolve();
    } else {
      reject(new Error(NOTLOGIN));
    }
  });
};

// 获取用户推荐
export const loadRecommend = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_RECOMMEND_INFO', recommend);
  });
};

// 添加地址
export const addAddress = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    let currentUser = localStorage.getItem(USER);
    if (currentUser) {
      currentUser = JSON.parse(currentUser);
      const address = JSON.parse(localStorage.getItem(ADDRESS)) || [];
      address.push(payload);
      localStorage.setItem(ADDRESS, JSON.stringify(address));
      commit('ADD_ADDRESS', payload);
    }
  });
};

export const loadAddress = ({ commit }) => {
  return new Promise((resolve, reject) => {
    let currentUser = localStorage.getItem(USER);
    if (currentUser) {
      currentUser = JSON.parse(currentUser);
      const address = JSON.parse(localStorage.getItem(ADDRESS)) || [];
      commit('SET_USER_ADDRESS', address);
    }
  });
};

export const loadShoppingCart = ({ commit }) => {
  return new Promise((resolve, reject) => {
    let currentUser = localStorage.getItem(USER);
    if (currentUser) {
      currentUser = JSON.parse(currentUser);
      const shoppongCart = JSON.parse(localStorage.getItem(SHOPPINGCART)) || [];
      commit('SET_SHOPPING_CART', shoppongCart);
    } else {
      // reject();
    }
  });
};

// 添加注册用户
export const addSignUpUser = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    let userArr = localStorage.getItem(USERS);
    let shoppingCart = localStorage.getItem(SHOPPINGCART);
    let order = localStorage.getItem(ORDER);
    let preorder = localStorage.getItem(PREORDER);
    let address = localStorage.getItem(ADDRESS);
    if (userArr) {
      userArr = JSON.parse(userArr);
    } else {
      userArr = [];
    }

    if (shoppingCart) {
      shoppingCart = JSON.parse(shoppingCart);
    } else {
      shoppingCart = {};
    }

    if (order) {
      order = JSON.parse(order);
    } else {
      order = {};
    }

    if (preorder) {
      preorder = JSON.parse(preorder);
    } else {
      preorder = {};
    }

    if (address) {
      address = JSON.parse(address);
    } else {
      address = {};
    }

    userArr.push(data);
    // 初始化当前用户的地址、购物车、订单、待付款
    shoppingCart[data.id] = [];
    order[data.id] = [];
    preorder[data.id] = [];
    address[data.id] = [];
    localStorage.setItem(USERS, JSON.stringify(userArr));
    localStorage.setItem(SHOPPINGCART, JSON.stringify(shoppingCart));
    localStorage.setItem(ORDER, JSON.stringify(order));
    localStorage.setItem(PREORDER, JSON.stringify(preorder));
    localStorage.setItem(ADDRESS, JSON.stringify(address));
  });
};

// 用户登录
export const login = ({ commit }, data) => {
  return new Promise((resolve, reject) => {
    register(data)
      .then(res => {
        localStorage.setItem(USER, JSON.stringify(res.user));
        localStorage.setItem(TOKEN, JSON.stringify(res.token));
        commit('SET_USER_LOGIN_INFO', {
          ...res.user
        });
        resolve(true);
      })
      .catch(err => {
        reject(err);
      });
  });
};

// 退出登陆
export const signOut = ({ commit }) => {
  localStorage.removeItem(USER);
  localStorage.removeItem(TOKEN);
  commit('SET_USER_LOGIN_INFO', {});
};

// 判断是否登陆
export const isLogin = ({ commit }) => {
  const user = localStorage.getItem(USER);
  if (user) {
    commit('SET_USER_LOGIN_INFO', JSON.parse(user));
  }
};

// 添加商铺
export const setShops = async ({ state, commit }) => {
  if (state.shops.length > 0) return;
  const res = await getShop();
  commit('SET_SHOPS', res);
};

export const setCata = async ({ state, commit }) => {
  if (state.cata.length > 0) return;
  const res = await getCata();
  commit('SET_CATA', res);
};

export const setData = async ({ state, commit }) => {
  if (state.goods.length > 0) return;
  const res = await getData();
  commit('SET_DATA', res);
};



// WEBPACK FOOTER //
// ./src/vuex/actions.js